<acl-ngx-accordion title="Performance Forecast" [open]="true">
  <div>
    <!-- <table class="table table-borderless">
    <thead>
      <tr>
        <th scope="col">Flight Dates</th>
        <th scope="col">Digital Video Budget</th>
        <th scope="col">Digital Video Impressions</th>
        <th scope="col">Digital Video eCPM</th> -->
    <!-- <th scope="col">Total Digital Video Reach</th> -->
    <!-- </tr>
    </thead>
    <tbody>
      <tr *ngIf="overallPerformanceForecastData">
        <td>{{overallPerformanceForecastData.flightSchedule.startDate | timezone : 'L' : planDetails.marketTimeZone}} -
          {{overallPerformanceForecastData.flightSchedule.endDate | timezone : 'L' : planDetails.marketTimeZone}}</td>
        <td>
          {{overallPerformanceForecastData.totalBudget | currency : planDetails.currency : 'symbol' : '1.0-0'}}
        </td>
        <td>{{overallPerformanceForecastData.totalImpressions | number : '1.0-2'}}</td>
        <td>{{overallPerformanceForecastData.totalCPM | currency : planDetails.currency : 'symbol' : '1.2'}}</td> -->
    <!-- <td>{{overallPerformanceForecastData.totalReach}}</td> -->
    <!-- </tr>
    </tbody>
  </table> -->

    <ng-template #budgetWidget>
      <div class="budget-widget">
        <label class="font-weight-bold">Budget</label>
        <div class="budget-chart">
          <div class="progress-text">
              {{(overallPerformanceForecastData.totalBudget * 100) / overallPerformanceForecastData.flightSchedule.spendingCap | number : '1.0-2' }}%
          </div>
          <div class="budget-chart-canvas">
            <canvas width="100%" height="100%" [colors]="doughnutChartColors" baseChart [options]="chartOptions"
              [data]="doughnutChartData" [labels]="doughnutChartLabels" [chartType]="doughnutChartType">
            </canvas>
          </div>
        </div>

        <div class="budget-detail">
          <div class="row margin-top-5">
            <div class="col-8">
              <div style="background-color: #009ebd;" class="d-inline-block tooltip-box"></div>
              <span class="budget-type">Allocated</span>
            </div>
            <div class="col-4 font-weight-bold">
              {{overallPerformanceForecastData.totalBudget | currency : planDetails.currency : 'symbol' : '1.0'}}
            </div>
          </div>
          <div class="row margin-top-5">
            <div class="col-8">
              <div style="background-color: #E2E2E2;" class="d-inline-block tooltip-box"></div>
              <span class="budget-type">Remaining</span>
            </div>
            <div class="col-4 font-weight-bold">
              {{overallPerformanceForecastData.flightSchedule.spendingCap - overallPerformanceForecastData.totalBudget  | currency : planDetails.currency : 'symbol' : '1.0'}}
            </div>
          </div>
          <hr>
          <div class="row margin-top-5">
            <div class="col-8">
              <span class="budget-type">Total Requested</span>
            </div>
            <div class="col-4 font-weight-bold">
              {{overallPerformanceForecastData.flightSchedule.spendingCap | currency : planDetails.currency : 'symbol' : '1.0'}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #goalsWidget>
      <div class="goals-widget">
        <label class="font-weight-bold">Goals</label>
        <div>
          <small>Forecasted goal Performance only considers non-guaranteed inventory.</small>
        </div>
        <br />
        <div class="goal-bar-chart">
          <acl-ngx-bar-chart [data]=goalPerformanceForeCastData?.results [barDataKeys]="keys" [xAxis]="mainXAxis"
            [yAxis]="mainYAxis" [enableLegend]=" true" [colors]="colors" [dataLabel]="dataLabel" [barSize]=60>
          </acl-ngx-bar-chart>
        </div>
      </div>
    </ng-template>

    <ng-template #totalsWidget>
      <div class="totals-widget">
        <label class="font-weight-bold">Totals</label>
        <br />
        <div>
          <small>Impressions</small>
          <h6>{{overallPerformanceForecastData.totalImpressions | number : '1.0-2'}}</h6>
        </div>
        <div>
          <small>CPM</small>
          <h6>{{overallPerformanceForecastData.totalCPM | currency : planDetails.currency : 'symbol' : '1.2'}}
          </h6>
        </div>
      </div>
    </ng-template>

    <ng-template #flightDatesWidget>
      <div class="flight-dates-widget">
        <label class="font-weight-bold">Flight Dates</label>
        <br />
        <div>
          <small>Start Date</small>
          <h6>{{overallPerformanceForecastData.flightSchedule.startDate | timezone : 'L' : planDetails.marketTimeZone}}
          </h6>
        </div>
        <div>
          <small>End Date</small>
          <h6>{{overallPerformanceForecastData.flightSchedule.endDate | timezone : 'L' : planDetails.marketTimeZone}}
          </h6>
        </div>
      </div>
    </ng-template>

    <div class="widget-container">
      <div class="row">
        <div class="col-3 budget-container">
          <acl-ngx-card [renderBody]="budgetWidget"></acl-ngx-card>
        </div>
        <div class="col-6 goals-container">
          <acl-ngx-card [renderBody]="goalsWidget"></acl-ngx-card>
        </div>
        <div class="col-3 details-container">
          <div class="totals-containter">
            <acl-ngx-card [renderBody]="totalsWidget"></acl-ngx-card>
          </div>
          <div class="flight-dates-containter">
            <acl-ngx-card [renderBody]="flightDatesWidget"></acl-ngx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</acl-ngx-accordion>
